import axios from 'axios';
import { ProductSchedule } from 'types';

export const fetchProductSchedule = (brandId: number, productId: number) => {
  return axios.get<ProductSchedule>(
    `/api/brands/${brandId}/products/${productId}/schedules`
  );
};
